import { Plugin, PluginKey } from '@tiptap/pm/state';

export const linkedHeadingGuardKey = new PluginKey('linkedHeadingGuard');

/**
 * ProseMirror plugin that prevents editing heading text inside sections
 * linked to an EHR section. Body content remains fully editable.
 * Section deletion is allowed — only heading text modification is blocked.
 */
export function createLinkedHeadingGuardPlugin(): Plugin {
  return new Plugin({
    key: linkedHeadingGuardKey,

    filterTransaction(transaction, state) {
      if (!transaction.docChanged) return true;

      const newDoc = transaction.doc;
      let blocked = false;

      state.doc.descendants((node, pos) => {
        if (blocked) return false;
        if (node.type.name !== 'sectionNode') return true;
        if (!node.attrs.linkedEhrSectionId) return false;

        const oldHeading = node.firstChild;
        if (!oldHeading || oldHeading.type.name !== 'heading') return false;

        const mapResult = transaction.mapping.mapResult(pos);
        if (mapResult.deleted) return false;

        const newSection = newDoc.nodeAt(mapResult.pos);
        if (!newSection || newSection.type.name !== 'sectionNode') return false;

        const newHeading = newSection.firstChild;
        if (!newHeading || newHeading.type.name !== 'heading') return false;

        if (oldHeading.textContent !== newHeading.textContent) {
          blocked = true;
        }

        return false;
      });

      return !blocked;
    },
  });
}
